var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6947 8.59371L14.8016 12.3887L15.721 17.7487C15.761 17.9831 15.6647 18.22 15.4722 18.36C15.3635 18.4393 15.2341 18.4793 15.1047 18.4793C15.0053 18.4793 14.9053 18.4556 14.8141 18.4075L10.0003 15.8768L5.18722 18.4068C4.97722 18.5181 4.72159 18.5 4.52909 18.3593C4.33659 18.2193 4.24034 17.9825 4.28034 17.7481L5.19972 12.3881L1.30597 8.59371C1.13597 8.42746 1.07409 8.17871 1.14784 7.95309C1.22159 7.72746 1.41722 7.56184 1.65284 7.52746L7.03347 6.74621L9.43972 1.86996C9.65034 1.44309 10.3503 1.44309 10.561 1.86996L12.9672 6.74621L18.3478 7.52746C18.5835 7.56184 18.7791 7.72684 18.8528 7.95309C18.9266 8.17934 18.8647 8.42684 18.6947 8.59371Z",
    fill: "url(#paint0_linear_657_167)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_167",
    x1: 10.0003,
    y1: 1.5498,
    x2: 10.0003,
    y2: 18.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78914"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.8461a978c6482ef69df8ecfe367ce1e0.svg";
export { ForwardRef as ReactComponent };